import classNames from 'classnames';
import { forwardRef } from 'react';

import styles from './Accordion.module.scss';
import { AccordionContext, AccordionProps } from './Accordion.types';

export const Accordion = forwardRef<HTMLDivElement, AccordionProps>(
  (
    {
      variant = 'tertiary',
      size = 'medium',
      chevronSide = 'left',
      disabled = false,
      withSeparators = false,
      className,
      ...props
    },
    ref
  ) => (
    <AccordionContext.Provider value={{ variant, size, chevronSide, withSeparators, disabled }}>
      <div className={classNames(styles.accordion, className)} {...props} ref={ref} />
    </AccordionContext.Provider>
  )
);
